/*
 * Copyright (c) 2023. Vitalii Kozyr
 */

package coreui.theme

import org.jetbrains.compose.web.css.px

object Typography {
    val displayLarge = 57.px
    val displayMedium = 45.px
    val displaySmall = 36.px
    val headlineLarge = 32.px
    val headlineMedium = 28.px
    val headlineSmall = 24.px
    val titleLarge = 22.px
    val titleMedium = 16.px
    val titleSmall = 14.px
    val labelLarge = 14.px
    val labelMedium = 12.px
    val labelSmall = 11.px
    val bodyLarge = 16.px
    val bodyMedium = 14.px
    val bodySmall = 12.px
}